import { parseDate } from '@ais-ui/utils';
import { QueryPointResult } from '@ais-ui/websockets';

export interface WindReport {
  windTimestamp: Date | null;
  avgWindSpeed: string;
  windGust: string;
  windDirection: string;
  windGustDirection: string;
  windSensorDataDescription: string;
}

const desiredReportKeys: string[] = [
  'avg_wind_speed',
  'timestamp',
  'wind_direction',
  'wind_gust',
  'wind_gust_direction',
  'wind_sensor_data_desc',
];

export function extractEnvironmentalWindReport(
  result: QueryPointResult
): WindReport {
  const rawWindReportInfo: { [key: string]: any } = {};
  for (const target of result.targetInfo) {
    const windReport = target?.values_json['wind_report'];
    if (windReport) {
      for (const [report_key, report_value] of Object.entries(windReport)) {
        if (desiredReportKeys.includes(report_key)) {
          rawWindReportInfo[report_key] = report_value;
        }
      }
    }
  }
  return {
    avgWindSpeed: rawWindReportInfo['avg_wind_speed'],
    windDirection: rawWindReportInfo['wind_direction'],
    windGust: rawWindReportInfo['wind_gust'],
    windGustDirection: rawWindReportInfo['wind_gust_direction'],
    windSensorDataDescription: rawWindReportInfo['wind_sensor_data_desc'],
    windTimestamp: parseDate(rawWindReportInfo['timestamp']),
  };
}
